import { LoaderCircle } from 'lucide-react';

export const Spinner = () => {
  return (
    <div className="flex items-center justify-center p-2">
      <LoaderCircle className="text-accent h-[40px] w-[40px] animate-spin" data-testid="loading-spinner" />
    </div>
  );
};
